import React from 'react';
import classNames from 'classnames';
import './Input.css';

export function Input({ 
  label,
  helper,
  error,
  icon,
  value,
  onChange,
  type = 'text',
  placeholder,
  className = '',
  ...props
}) {
  const inputClasses = classNames(
    'agrisense-input__field',
    {
      'agrisense-input__field--error': error,
      'agrisense-input__field--with-icon': icon,
    },
    className
  );

  return (
    <div className="agrisense-input">
      {label && (
        <label className="agrisense-input__label">{label}</label>
      )}
      <div className="agrisense-input__wrapper">
        {icon && (
          <span className="agrisense-input__icon">{icon}</span>
        )}
        <input
          className={inputClasses}
          type={type}
          value={value}
          onChange={(e) => onChange(e.target.value)}
          placeholder={placeholder}
          data-testid="input"
          {...props}
        />
      </div>
      {helper && !error && (
        <span className="agrisense-input__helper">{helper}</span>
      )}
      {error && (
        <span className="agrisense-input__error">{error}</span>
      )}
    </div>
  );
}